import { useCallback } from 'react';

import { HIDDEN_VARIABLES_TABS } from 'containers/QuestionnaireLogic/constants';
import useRedirect from 'containers/App/hooks/useRedirect';

function useNavigation({ surveyId }) {
  const redirect = useRedirect();
  const goToLogic = useCallback(() => {
    if (window.location.href.includes('advanced-logic')) {
      return;
    }
    redirect(`/survey/questionnaire/${surveyId}/advanced-logic`);
  }, [redirect, surveyId]);

  const goToDisplayLogic = useCallback(
    (payload) => {
      if (window.location.href.includes('display-logic')) {
        return false;
      }

      redirect(`/survey/questionnaire/${surveyId}/display-logic`, payload);

      return true;
    },
    [redirect, surveyId],
  );
  const goToHiddenVariableLogic = useCallback(() => {
    redirect(`/survey/questionnaire/${surveyId}/hidden-variables`, {
      activeKey: HIDDEN_VARIABLES_TABS.RULES,
    });
  }, [redirect, surveyId]);

  const goToQuotaLogic = useCallback(() => {
    if (window.location.href.includes('advanced-quota-logic')) {
      return;
    }
    redirect(`/survey/questionnaire/${surveyId}/advanced-quota-logic`);
  }, [redirect, surveyId]);

  return {
    goToLogic,
    goToDisplayLogic,
    goToHiddenVariableLogic,
    goToQuotaLogic,
  };
}

export default useNavigation;
